import { IconButton } from '@amzn/storm-ui';
import styled from 'styled-components';

export const StyledIconButton = styled(IconButton)<{
  backgroundColor?: string;
}>`
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.color.blue[700]};
`;
